// PC端
import Header from "./components/PC/Layout/Header/Header"
import Footer from "./components/PC/Layout/Footer/footer"
import Home from "./components/PC/Home/home"
import About from "./components/PC/About/about"
import Production from "./components/PC/Production/production"
import Contact from "./components/PC/Contact/contact"

// 移动端
import MHeader from "./components/mobile/Header/Header"
import MHome from "./components/mobile/Home/home"
import MAbout from "./components/mobile/About/about"
import MProduction from "./components/mobile/Production/production"
import MContact from "./components/mobile/Contact/contact"

// 试用页面
// import ALL from "./components/all"


import './App.css';

function App() {
  // 获取点击的菜单
  const getMenuIdFn = (menuId)=>{
    pageScroll(menuId)
  }
  // 跳转函数
  const pageScroll = (anchorName) => {
    if(anchorName){
      let anchorElement = document.getElementById(anchorName);
      const distanceToTop = anchorElement.offsetTop;
      if(distanceToTop) {
        window.scrollTo(
          {
            top: distanceToTop - 160,
            behavior: 'smooth'
          }
        ); 
      }
      // window.history.pushState({},0,anchorName.split('-')[0])  // 上服务器后，点击锚点重定向问题，注释后消失
      // 提PR失败，重新拉取dev分支代码到main，然后提交，再提PR
    }
  }
  // return <ALL></ALL>
  // 判断移动端和PC端
  let userAgent = navigator.userAgent.toLowerCase();
  // 用 test 匹配浏览器信息
  if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(userAgent)) {
      return (
        <div className="App" style={{ paddingTop:'0px' }}>
              
          <MHeader></MHeader>
          <MHome></MHome>
          <MAbout></MAbout>
          <MProduction></MProduction>
          <MContact></MContact>
        </div>
      );
  } else {
    return (
      <div className="App" style={{ paddingTop:'151px' }}>
            <Header onData={ getMenuIdFn } />
            <Home />
            <About />
            <Production />
            <Contact />
            <Footer />
      </div>
    );
  }

}

export default App;
